import { createContext } from 'react';

export type AppContextType = {
  AVMLink: string;
  apiUrl: string;
  scenarioDemo: string;
  scenarioExample: string;
};

export const AppContext = createContext<AppContextType>({
  apiUrl: '',
  AVMLink: '',
  scenarioDemo: '',
  scenarioExample: '',
});
